import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { Button, Input, Label } from "@bloom/ui";
import { useLocale } from "../locale/locale-context.tsx";
import { AuthShell } from "./login.tsx";

export function SignupPage() {
  const { t } = useLocale();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const res = await fetch("/api/auth/sign-up/email", {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ email, password, name }),
      });
      if (!res.ok) {
        const body = (await res.json()) as { message?: string };
        setError(body.message ?? "Signup failed");
        return;
      }
      navigate(`/verify-email?email=${encodeURIComponent(email)}`);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell heading={t("auth.signup")} variant="signup">
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1">
          <Label htmlFor="name">{t("auth.email").replace("ail", "ail / Name")}</Label>
          <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div className="space-y-1">
          <Label htmlFor="email">{t("auth.email")}</Label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor="password">{t("auth.password")}</Label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
        </div>
        {error ? <p className="text-sm text-[var(--brand-rose)]">{error}</p> : null}
        <Button type="submit" className="w-full" disabled={submitting}>
          {t("auth.continue")}
        </Button>
      </form>
      <p className="text-center text-sm">
        {t("auth.have_account")}{" "}
        <Link to="/login" className="font-semibold text-[var(--brand-rose)]">
          {t("auth.login")}
        </Link>
      </p>
    </AuthShell>
  );
}
